(ns common.schema.entities.lp-portal.lp-report-holding
  (:require
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def hardcoded-holding-templates
  {:lp-report-holding-template/no-reporting "--- NO REPORTING ---"
   :lp-report-holding-template.capman/private-equity-company "PE Company"
   :lp-report-holding-template.capman/private-equity-special-situations "Special situations company"
   :lp-report-holding-template.capman/private-equity-exit-company "Exit company"
   :lp-report-holding-template.capman/private-equity-investment-company "New investment company"
   :lp-report-holding-template.capman/natural-capital-investment "Dasos company"
   :lp-report-holding-template.capman/credit-company "Credit Company"
   :lp-report-holding-template.capman/infra-company "Infra company"
   :lp-report-holding-template.capman/real-estate-portfolio-hotels "RE portfolio Hotels"
   :lp-report-holding-template.capman/real-estate-portfolio-hotels-esg "RE portfolio Hotel (ESG)"
   :lp-report-holding-template.capman/real-estate-property-hotels-esg "RE property Hotel (ESG)"
   :lp-report-holding-template.capman/real-estate-portfolio-koke "RE portfolio Koke"
   :lp-report-holding-template.capman/real-estate-portfolio-koke-esg "RE portfolio Koke (ESG)"
   :lp-report-holding-template.capman/real-estate-property-koke-esg "RE property Koke (ESG)"
   :lp-report-holding-template.capman/real-estate-portfolio-resi "RE portfolio Resi"
   :lp-report-holding-template.capman/real-estate-portfolio-resi-esg "RE portfolio Resi (ESG)"
   :lp-report-holding-template.capman/real-estate-property-resi-esg "RE property Resi (ESG)"
   :lp-report-holding-template.capman/real-estate-property-stockholm-living "RE Stockholm living property"
   :lp-report-holding-template.capman/real-estate-property-nre "RE property Value-add"
   :lp-report-holding-template.capman/real-estate-property-nre-esg "RE property Value-add (ESG)"
   :lp-report-holding-template.capman/real-estate-portfolio-nre-esg "RE portfolio Value-add with ESG"
   :lp-report-holding-template.capman/real-estate-new-investment "RE new investment"
   :lp-report-holding-template.capman/real-estate-exit-property "RE exit"
   :lp-report-holding-template.invest-europe/holding "Invest Europe - Private Equity - Previously reported investment"
   :lp-report-holding-template.invest-europe/new-investment "Invest Europe - Private Equity - New investment"
   :lp-report-holding-template.invest-europe/exit "Invest Europe - Private Equity - Exited investment"
   :lp-report-holding-template.sparkmind/private-equity-company "Sparkmind - Private Equity company"
   :lp-report-holding-template.innovestor/holding "Innovestor holding template"
   :lp-report-holding-template.innovestor/technology-fund-holding "Innovestor holding template (Tech)"
   :lp-report-holding-template.innovestor/technology-fund-holding-v2 "Innovestor holding template (Tech) [Bulk import]"
   :lp-report-holding-template.lifeline/holding "Lifeline Ventures - Previously reported investment"
   :lp-report-holding-template.lifeline/exited-holding "Lifeline Ventures - Exited investment"})

(defn view-order
  [template-type]
  (let [res (case template-type
              :lp-report-holding-template/no-reporting 1000
              :lp-report-holding-template.capman/private-equity-exit-company 0
              :lp-report-holding-template.capman/real-estate-exit-property 0
              :lp-report-holding-template.capman/private-equity-investment-company 1
              :lp-report-holding-template.capman/natural-capital-investment 1
              :lp-report-holding-template.capman/real-estate-new-investment 1
              :lp-report-holding-template.invest-europe/new-investment 0
              :lp-report-holding-template.invest-europe/holding 1
              :lp-report-holding-template.invest-europe/exit 2
              :lp-report-holding-template.sparkmind/private-equity-company 0
              :lp-report-holding-template.innovestor/holding 0
              :lp-report-holding-template.lifeline/holding 0
              :lp-report-holding-template.lifeline/exited-holding 1
              ;; all the rest
              2)]
    res))

(defn compare-holdings
  [r1 r2]
  (let [t1 (:lp-report-holding/template-type r1)
        t2 (:lp-report-holding/template-type r2)
        n1 (:lp-report-holding/name r1)
        n2 (:lp-report-holding/name r2)
        o1 (:common/ord r1)
        o2 (:common/ord r2)
        t-ord (compare (view-order t1)
                       (view-order t2))
        o-ord (compare o1 o2)]
    (cond (not (zero? t-ord))
          t-ord
          (not (zero? o-ord))
          o-ord
          :else
          (compare n1 n2))))

(def holding-template-options
  (->> hardcoded-holding-templates
       (map (fn [[k l]]
              {:key   k
               :label l}))
       (doall)))

(def publishing-statuses
  {:lp-report-holding.publishing-status/wip      "WIP"
   :lp-report-holding.publishing-status/pending-approval "Waiting for approval"
   :lp-report-holding.publishing-status/approved "Approved"})

(def publishing-status-options
  (->> publishing-statuses
       (map (fn [[k l]]
              {:key   k
               :label l}))
       (doall)))

(defn entity-ids
  [entities-or-ids]
  (->> entities-or-ids
       (mapv (fn [eid]
               (or (:db/id eid) eid)))))

(defn can-view?
  [{:keys [fund-report holding-report account-id admin?]}]
  (or admin?
      (some #{account-id}
            (entity-ids (concat (:lp-report/process-owners fund-report)
                                (:lp-report-holding/text-contributors holding-report)
                                (:lp-report-holding/data-contributors holding-report)
                                (:lp-report/text-contributors fund-report)
                                (:lp-report/data-contributors fund-report)
                                (:lp-report/followers fund-report)
                                [(:lp-report-holding/text-approver holding-report)
                                 (:lp-report-holding/data-approver holding-report)
                                 (:lp-report/data-approver fund-report)
                                 (:lp-report/text-approver fund-report)
                                 (:lp-report/final-approver fund-report)])))))

(defn can-edit-text?
  [{:keys [fund-report holding-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (entity-ids (concat (:lp-report-holding/text-contributors holding-report)
                                [(:lp-report-holding/text-approver holding-report)
                                 (:lp-report/final-approver fund-report)])))))

(defn can-edit-footers?
  [{:keys [fund-report holding-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (entity-ids (concat (:lp-report-holding/data-contributors holding-report)
                                (:lp-report-holding/text-contributors holding-report)
                                [(:lp-report-holding/text-approver holding-report)
                                 (:lp-report-holding/data-approver holding-report)
                                 (:lp-report/final-approver fund-report)])))))

(defn can-select-data-set?
  [{:keys [fund-report holding-report account-id admin-or-owner?]}]
  (let [data-selectors (:lp-report-holding/chart-selector-roles holding-report)]
    (or admin-or-owner?
        (some #{account-id}
              (entity-ids (concat [(:lp-report/final-approver fund-report)]
                                  (when (some #{:lp-report-holding/data-contributors} data-selectors)
                                    (:lp-report-holding/data-contributors holding-report))
                                  (when (some #{:lp-report-holding/text-contributors} data-selectors)
                                    (:lp-report-holding/text-contributors holding-report))
                                  (when (some #{:lp-report-holding/text-approver} data-selectors)
                                    [(:lp-report-holding/text-approver holding-report)])
                                  (when (some #{:lp-report-holding/data-approver} data-selectors)
                                    [(:lp-report-holding/data-approver holding-report)])))))))

(defn can-edit-chart?
  [{:keys [fund-report holding-report account-id admin-or-owner?]}]
  (let [data-selectors (:lp-report-holding/chart-editor-roles holding-report)]
    (or admin-or-owner?
        (some #{account-id}
              (entity-ids (concat [(:lp-report/final-approver fund-report)]
                                  (when (some #{:lp-report-holding/data-contributors} data-selectors)
                                    (:lp-report-holding/data-contributors holding-report))
                                  (when (some #{:lp-report-holding/text-contributors} data-selectors)
                                    (:lp-report-holding/text-contributors holding-report))
                                  (when (some #{:lp-report-holding/text-approver} data-selectors)
                                    [(:lp-report-holding/text-approver holding-report)])
                                  (when (some #{:lp-report-holding/data-approver} data-selectors)
                                    [(:lp-report-holding/data-approver holding-report)])))))))

(defn can-update-data?
  [{:keys [holding-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (entity-ids (concat (:lp-report-holding/data-contributors holding-report)
                                [(:lp-report-holding/data-approver holding-report)])))))

(defn can-approve-text?
  [{:keys [fund-report holding-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (entity-ids [(:lp-report-holding/text-approver holding-report)
                         (:lp-report/final-approver fund-report)]))))

(defn can-approve-data?
  [{:keys [holding-report account-id admin-or-owner?]}]
  (or admin-or-owner?
      (some #{account-id}
            (entity-ids [(:lp-report-holding/data-approver holding-report)]))))

(def schema
  (concat (su/text-simple-field :lp-report-holding/name "Name" {:authorization su/access-user-lpg})
          (su/keyword-field :lp-report-holding/template-type
                            "Template"
                            holding-template-options
                            {:authorization su/access-user-lpg})
          (su/keyword-field :lp-report-holding/text-status
                            "Text status"
                            publishing-status-options
                            {:authorization su/access-user-user})
          (su/keyword-field :lp-report-holding/data-status
                            "Data status"
                            publishing-status-options
                            {:authorization su/access-user-user})
          (su/single-ref-field :lp-report-holding/text-approver
                               "Text approver"
                               [:entity.type/account]
                               {:authorization su/access-user-user})
          (su/single-ref-field :lp-report-holding/data-approver
                               "Data approver"
                               [:entity.type/account]
                               {:authorization su/access-user-user})
          (su/multi-ref-field :lp-report-holding/data-contributors
                              "Data contributors"
                              [:entity.type/account]
                              {:authorization su/access-user-user
                               :default-field-visibility :in-use})
          (su/multi-ref-field :lp-report-holding/text-contributors
                              "Text contributors"
                              [:entity.type/account]
                              {:authorization su/access-user-user
                               :default-field-visibility :in-use})
          (su/text-edn-field :lp-report-holding/data
                             "Data"
                             {:authorization su/access-user-lpg})
          (su/single-ref-field :lp-report-holding/report-data-file
                               "Fund report data file"
                               [:entity.type/attachment]
                               {:authorization su/access-user-user})
          (su/text-edn-field :lp-report-holding/report-data-status
                             "Fund report data status"
                             (system-controlled {:authorization su/access-system-user}))
          (su/text-edn-field :lp-report-holding/editable-data
                             "Editable dta"
                             (system-controlled {:authorization su/access-system-lpg}))
          (su/keyword-multi-field :lp-report-holding/chart-editor-roles
                                  "Chart editor roles"
                                  nil
                                  {:authorization su/access-user-user})
          (su/keyword-multi-field :lp-report-holding/chart-selector-roles
                                  "Chart selector roles"
                                  nil
                                  {:authorization su/access-user-user})))
